(function Reports($, Adzuki)
{
	"use strict";

	$(document).ready(function documentReady()
	{
		Adzuki.onload('/Reports/index', function onload()
		{
			$('.view-snapshot').click(function showLoader() {
				$('.form-loader').removeClass('invisible');
			});

			$('.report-generator').click(function loadReport() {
				var report_id = $("#generated_report_id").val(),
					url       = '/GeneratorReports/registerSession/' + report_id;
				Adzuki.Ajax.get(url).then(function registerSessionAndLoadReport(response)
				{
					if (response.status === true) {
						window.location.href = Adzuki.base_uri + '/GeneratorReports/reportResults';
					} else {
						Adzuki.StatusMessage(null, 'There was an issue pulling this report. Please try again later.', 'There was an issue');
					}
				});
			});
		});
	});
}(jQuery, window.Adzuki || {}));
